import StyledContainer from "style/styledContainer"
import styled, { css } from "styled-components"
import DrawerCom from "./DrawerCom"

import BaseBtnCom from "../BaseBtnCom"
import { CancelTextBtnWrap, DrawerWinOneTileWrap, DrawerWinTwoTileWrap, PaddingLeftRightWrap } from "./DrawerStyle"
import { useCallback, useEffect, useState } from "react"
import WarnBarCom from "components/WarnBarCom"
import { useAccount, useNetwork, useSwitchNetwork } from "wagmi"
import { Row } from "style/preset"
import SvgCom from "components/SvgCom"

import { ReactComponent as DaoBalanceSvg } from 'assets/svgs/dao_balance.svg'
import CNumberCom from "components/Form/CNumberCom"
import useTools from "hooks/useTools"
import { formatNum } from "utils"
import useDao from "hooks/useDao"
import LoadingWin from "components/LoadingWin"

interface Props {
    open: boolean
    closeChange?: (isOpen: boolean) => void
    onComplete?: (obj?: any) => void
}

const timeOptions = [
    {
        title: '6 Months',
        day: '180',
        month: '6'
    },
    {
        title: '1 Year',
        day: '365',
        month: '12'
    },
    {
        title: '2 Years',
        day: '730',
        month: '24'
    },
    {
        title: '4 Years',
        day: '1460',
        month: '48'
    }
]

const DrawerStakeCom = ({open, closeChange = (isOpen) => {}, onComplete = (obj) => {}}: Props) => {
    const { address } = useAccount()
    const { createStake, isLock } = useDao(false)
    const { getBalanceForEvm } = useTools()
    const [balance, setBalance] = useState('0')
    const [curTime, setCurTime] = useState(timeOptions[0])
    const [amount, setAmount] = useState('')
    const [amountByV, setAmountByV] = useState('0')
    const [isExceed, setIsExceed] = useState(false)
    const { chain: curChain } = useNetwork();
    const [btnLabel, setBtnLabel] = useState('')
    const { switchNetworkAsync } = useSwitchNetwork();

    const fnGetBalance = useCallback(async () => {
        if(address) {
            // const result = await getBalanceForEvm('ARB', '0x51c601dc278eb2cfea8e52c4caa35b3d6a9a2c26', address)

            const result = await getBalanceForEvm('ETH', '0xb712d62fe84258292d1961b5150a19bc4ab49026', address)
            setBalance(result)
        }
    }, [address, getBalanceForEvm])

    /**
     * 资源初始化
     */
    const fnInit = useCallback(() => {
        if(open) {
            fnGetBalance()
        } else {
            // 清理资源
            setAmount('')
            setCurTime(timeOptions[0])
        }
    }, [open, fnGetBalance])

    useEffect(() => {
        fnInit()
    }, [fnInit])

    useEffect(() => {
        fnGetBalance()
    }, [fnGetBalance])

    /**
     * 关闭回调
     */
    const [closeRandom, setCloseRandom] = useState(0)
    const fnClosed = (closed: boolean) => {
        closeChange(closed)
        setCloseRandom(0)
    }
    const fnCloseWin = useCallback(() => {
        setCloseRandom(closeRandom + 1)
    }, [closeRandom])

    /**
     * 完成回调
     */
    const fnConfirm = useCallback(async () => {
        if(btnLabel === 'Stake now') {
            await createStake(amount, curTime.month)
            setTimeout(() => {
                fnGetBalance()
            }, 3000);
        } else {
            try {
                // await switchNetworkAsync?.(42161);
                await switchNetworkAsync?.(1);
            } catch (error) {
            } finally {
                return;
            }
        }
    }, [btnLabel, createStake, amount, curTime.month, fnGetBalance, switchNetworkAsync])

    // 业务逻辑
    const fnTxhashChange = (val: string) => {
        setAmount(val)
    }

    useEffect(() => {
        if((+amount) > (+balance)) {
            setIsExceed(true)
        } else {
            setIsExceed(false)
        }
    }, [amount, balance])

    useEffect(() => {
        let tempAmountByV = 0
        if (curTime.month === '6') tempAmountByV = (+amount);
        if (curTime.month === '12') tempAmountByV = (+amount) * 3 / 2;
        if (curTime.month === '24') tempAmountByV =  (+amount) * 3;
        if (curTime.month === '48') tempAmountByV =  (+amount) * 8;
        setAmountByV(tempAmountByV + '')
    }, [amount, curTime])

    // check network
    useEffect(() => {
        if(curChain && curChain.id !== 1) {
            setBtnLabel('Switch chain to Ethereum')
        } else {
            setBtnLabel('Stake now')
        }
    }, [curChain])

    return open ? <DrawerCom isOpen={open} closeRandom={closeRandom} onClose={fnClosed}>
        <DrawerContentWrap $isError={true}>
            <PaddingLeftRightWrap>
                <DrawerWinOneTileWrap>Stake XCHNG</DrawerWinOneTileWrap>
                <DrawerWinTwoTileWrap $mb="20px">The amount of XCHNG staked will be deducted from your available balance on the Ethereum chain.</DrawerWinTwoTileWrap>
                <StyledContainer $height="36px"></StyledContainer>

                <CNumberCom value={amount} label="XCHNG Amount" onChange={fnTxhashChange}></CNumberCom>
                <StyledContainer $height="20px"></StyledContainer>
                <Row $justifyContent="space-between">
                    <Row>
                        <SvgCom Svg={DaoBalanceSvg} size="16"></SvgCom>
                        <StyledContainer $ml="6px" $fontSize="12px" $lineHeight="14px" $fontWeight4 $color="#767A7F">Balance</StyledContainer>
                    </Row>

                    <StyledContainer $fontSize="12px" $lineHeight="14px" $fontWeight5 $color="#767A7F">{formatNum(balance, 2)} XCHNG</StyledContainer>
                </Row>
                <StyledContainer $height="10px"></StyledContainer>
                {
                    isExceed && <WarnBarCom isError={true} desc="It exceeds your XCHNG balance"></WarnBarCom>
                }
            </PaddingLeftRightWrap>
            <StyledContainer $height="10px"></StyledContainer>
            <PartingLineWrap></PartingLineWrap>
            <StyledContainer $height="30px"></StyledContainer>
            <PaddingLeftRightWrap>
                <StyledContainer $fontSize="14px" $lineHeight="16px" $fontWeight6>For what duration are you going to stake?</StyledContainer>
                <Row $mt="15px">
                    {
                        timeOptions.map((item, index) => <BtnWrap key={index} $active={curTime.day === item.day} onClick={() => setCurTime(item)}>{item.title}</BtnWrap>)
                    }
                </Row>
            </PaddingLeftRightWrap>
            <StyledContainer $height="30px"></StyledContainer>
            <PartingLineWrap></PartingLineWrap>
            <StyledContainer $height="30px"></StyledContainer>
            <PaddingLeftRightWrap>
                <StyledContainer $fontSize="14px" $lineHeight="16px" $fontWeight6>You will receive</StyledContainer>
                <StyledContainer $fontSize="18px" $lineHeight="18px" $fontWeight7 $mt="8px" $mb="50px">{formatNum(amountByV, 2)} vXCHNG</StyledContainer>
                
                <BaseBtnCom disabled={(btnLabel === 'Stake now' && (isExceed || (+amount) <= 0))} type="6" title={btnLabel} onClick={fnConfirm}></BaseBtnCom>
                <CancelTextBtnWrap onClick={() => setCloseRandom(closeRandom + 1)}>Cancel</CancelTextBtnWrap>
            </PaddingLeftRightWrap>
        </DrawerContentWrap>
        <LoadingWin loading={isLock}></LoadingWin>
    </DrawerCom> : <></>
}

const DrawerContentWrap = styled(StyledContainer)<{$isError: boolean}>`
    ${
        ({$isError, theme}) => $isError ? css`
         
        ` : css`
        `
    }
`

const PartingLineWrap = styled(StyledContainer)`
    height: 1px;
    width: 100%;
    background-color: #DFE0E2;
`

const BtnWrap = styled(StyledContainer)<{$active: boolean}>`
    font-size: 14px;
    line-height: 1;
    font-weight: 500;
    padding: 8px 10px;
    border-radius: 6px;
    margin-right: 10px;
    cursor: pointer;
    color: ${({$active}) => $active ? '#ffffff' :  '#0a0a0a'};
    background-color: ${({$active}) => $active ? '#4D1DF7' :  '#F6F5F4'};


    &:hover {
        color: #ffffff;
        background-color: #4D1DF7;
    }
`

export default DrawerStakeCom